/** @format */

import { Action } from '@ngrx/store';
import { Activity, ActivityList, TaskPayload, TaskList } from 'src/app/models/activity';
import { Problem, ProblemDB, NewProblem, ProblemContact, DuplicateProblemPayload } from 'src/app/models/problem';
import {
	MenuItem,
	ProblemCategorySubType,
	ProblemSubType,
	UserNotification,
	UpdateActivityDetails,
	SearchCoordinatesPayload,
	SearchResultsPayload,
	ProblemMenuConfig,
	LookupOwnerPayload,
	ProblemContactsPayload,
	DeleteEntityPayload,
	ReassignProblemPayload,
	ProblemCodeCasePayload,
	AddActivityPayload,
	GetMenuOptionPayload,
	GetProblemsPayload,
	GetContactsPayload,
	HeartbeatPayload,
	SearchFromCoordinatesPayload,
	SubmitWorkOrderPayload,
	AssetPayload,
	DeleteWorkOrderPayload,
	AddWorkOrderPayload,
	SaveSearchQueryPayload,
	SearchQuery,
	CancelActivityPayload,
	ProblemNeighborPayload,
	ProblemNeighborScope,
	LinkedCasePayload,
	UpdateLinkedCasePayload,
	UnlinkProblemCasePayload,
	FromProblemLinkedCasePayload,
	LinkedCaseRelated,
	RenewArcGisTokenPayload,
	User,
	AdminUserView,
	Group,
	Role,
	SelectedProblemSubType,
	CityWorksRequestViewResponse,
	CityworksTransferMapping,
} from './application.state';
import { History } from 'src/app/models/history';
import { DashboardTabView, Asset, LinkedCase } from 'src/app/state-management';
import { DnvMarker, DnvLatLng, DnvMapInfo } from 'dnv-lib';
import {
	Attachment,
	UploadAttachmentsPayload, // initialUploadAttachmentsPayload,
	UpdateAttachmentDetails,
} from 'src/app/models/attachment';
import { NgxGalleryAction, NgxGalleryImage } from '@vinlos/ngx-gallery';

export const ApplicationActionType = {
	DownloadEdocsFile: '[application] DownloadEdocsFile',
	DownloadAzureFile: '[application] DownloadAzureFile',
	DelayedAction: '[application] DelayedAction',
	DelayedActionBy1: '[application] DelayedActionBy1',
	DeleteAttachment: '[application] DeleteAttachment',
	DeleteContact: '[application] DeleteContact',
	DeleteContactSuccess: '[application] DeleteContactSuccess',
	DeleteContactError: '[application] DeleteContactError',
	DeletePhone: '[application] DeletePhone',
	DeletePhoneSuccess: '[application] DeletePhoneSuccess',
	DeletePhoneError: '[application] DeletePhoneError',
	GetMenuOption: '[application] GetMenuOption',
	GetMenuOptionSuccess: '[application] GetMenuOptionSuccess',
	GetMenuOptionError: '[application] GetMenuOptionError',
	Idle: '[application] Idle',
	Layer: '[application] Layer',
	GetLayers: '[application] GetLayers',
	CheckLayerDisplay: '[application] CheckLayerDisplay',
	SetProblemNeighborScope: '[application] SetProblemNeighborScope',
	SetProblemNeighborScopeSuccess: '[application] SetProblemNeighborScopeSuccess',
	GetProblemNeighbors: '[application] GetProblemNeighbors',
	GetProblemNeighborsSuccess: '[application] GetProblemNeighborsSuccess',
	GetProblems: '[application] GetProblems',
	GetProblemsSuccess: '[application] GetProblemsSuccess',
	GetProblemsError: '[application] GetProblemsError',
	GetDashBoardProblems: '[application] GetDashBoardProblems',
	GetDashBoardProblemsSuccess: '[application] GetDashBoardProblemsSuccess',
	GetDashBoardProblemsError: '[application] GetDashBoardProblemsError',
	Heartbeat: '[application] Heartbeat',
	HeartbeatSuccess: '[application] HeartbeatSuccess',
	HeartbeatError: '[application] HeartbeatError',
	SetMenuOption: '[application] SetMenuOption',
	SetMenuDictionaries: '[application]  SetMenuDictionaries',
	SetProblems: '[application] SetProblems',
	SetDashBoardProblems: '[application] SetDashBoardProblems',
	SetProblemsFiltered: '[application] SetProblemsFiltered',
	SelectProblem: '[application] SelectProblem',
	SetProblemMarkers: '[application] SetProblemMarkers',
	SetDashboardView: '[application] SetDashboardView',
	ToggleCategoryExpanded: '[application] ToggleCategoryExpanded',
	// ToggleProblemExpanded: '[application] ToggleProblemExpanded',
	SetNoMapLocation: '[application] SetNoMapLocation',
	UpdateWindowSize: '[application] UpdateWindowSize',
	GetActivity: '[application] GetActivity',
	GetActivities: '[application] GetActivities',
	GetAsset: '[application] GetAsset',
	GetTask: '[application] GetTask',
	GetTasks: '[application] GetTasks',
	GetTaskSuccess: '[application] GetTaskSuccess',
	GetTaskError: '[application] GetTaskError',
	// SetActivity: '[application] SetActivity',
	SetAccess: '[application] SetAccess',
	SetActivities: '[application] SetActivities',
	SetAsset: '[application] SetAsset',
	SetTasks: '[application] SetTasks',
	SetNewCaseNo: '[application] SetNewCaseNo',
	SetDashboardTabView: '[application] SetDashboardTabView',
	AddActivity: '[application] AddActivity',
	AddActivitySuccess: '[application] AddActivitySuccess',
	AddActivityError: '[application] AddActivityError',
	GetDashboardView: '[application] GetDashboardView',
	GetDashboardViewSuccess: '[application] GetDashboardViewSuccess',
	GetDashboardViewError: '[application] GetDashboardViewError',
	SaveDashboardView: '[application] SaveDashboardView',
	SaveDashboardViewSuccess: '[application] SaveDashboardViewSuccess',
	SaveDashboardViewError: '[application] SaveDashboardViewError',
	AddAsset: '[application] AddAsset',
	AddAssetSuccess: '[application] AddAssetSuccess',
	AddAssetError: '[application] AddAssetError',
	DeleteAsset: '[application] DeleteAsset',
	DeleteAssetSuccess: '[application] DeleteAssetSuccess',
	DeleteAssetError: '[application] DeleteAssetError',
	AddCodeCase: '[application] AddCodeCase',
	AddCodeCaseSuccess: '[application] AddCodeCaseSuccess',
	AddCodeCaseError: '[application] AddCodeCaseError',
	AddPermit: '[application] AddPermit',
	AddPermitSuccess: '[application] AddPermitSuccess',
	AddPermitError: '[application] AddPermitError',
	CancelActivity: '[application] CancelActivity',
	CancelActivitySuccess: '[application] CancelActivitySuccess',
	CancelActivityError: '[application] CancelActivityError',
	UpdateActivity: '[application] UpdateActivity',
	UpdateActivityClose: '[application] UpdateActivityClose',
	UpdateActivitySuccess: '[application] UpdateActivitySuccess',
	UpdateActivityError: '[application] UpdateActivityError',
	AddProblem: '[application] AddProblem',
	//  GetCategorySubType: '[application] GetCategorySubType',
	SetCategorySubType: '[application] SetCategorySubType',
	AddCaseGotoStep: '[application] AddCaseGotoStep',
	SetSelectedProblemType: '[application] SetSelectedProblemType',
	GetAllProblemSubTypes: '[application] GetAllProblemSubTypes',
	SetAllProblemSubTypes: '[application] SetAllProblemSubTypes',
	ReassignProblem: '[application] ReassignProblem',
	ReassignProblemSuccess: '[application] ReassignProblemSuccess',
	ReassignProblemError: '[application] ReassignProblemError',
	// ReassignGroupProblem: '[application] ReassignGroupProblem',
	// ReassignGroupProblemSuccess: '[application] ReassignGroupProblemSuccess',
	// ReassignGroupProblemError: '[application] ReassignGroupProblemError',
	ToastUserNotification: '[application] ToastUserNotification',
	RedirectPath: '[application] RedirectPath',
	GetProblemHistory: '[application] GetProblemHistory',
	GetProblemHistorySuccess: '[application] GetProblemHistorySuccess',
	GetProblemHistoryError: '[application] GetProblemHistoryError',
	UpdateProblem: '[application] UpdateProblem',
	GetDescriptionHistory: '[application] GetDescriptionHistory',
	SetDescriptionHistory: '[application] SetDescriptionHistory',
	SetRapUsers: '[application] SetRapUsers',
	GetProblemContacts: '[application] GetProblemContacts',
	GetProblemContactsSuccess: '[application] GetProblemContactsSuccess',
	GetProblemContactsError: '[application] GetProblemContactsError',
	AddProblemContacts: '[application] AddProblemContacts',
	AddProblemContactsSuccess: '[application] AddProblemContactsSuccess',
	AddProblemContactsError: '[application] AddProblemContactsError',
	SetProblemContacts: '[application] SetProblemContacts',
	UpdateContact: '[application] UpdateContact',
	SetZoneLookupOnly: '[application] SetZoneLookupOnly',
	SetSearchCoordinates: '[application] SetSearchCoordinates',
	SearchCoordinates: '[application] SearchCoordinates',
	SearchCoordinatesSuccess: '[application] SearchCoordinatesSuccess',
	SearchCoordinatesError: '[application] SearchCoordinatesError',
	SearchFromCoordinates: '[application] SearchFromCoordinates',
	SearchFromCoordinatesSuccess: '[application] SearchFromCoordinatesSuccess',
	SearchFromCoordinatesError: '[application] SearchFromCoordinatesError',
	LookupOwner: '[application] LookupOwner',
	LookupOwnerSuccess: '[application] LookupOwnerSuccess',
	LookupOwnerReset: '[application] LookupOwnerReset',
	LookupOwnerError: '[application] LookupOwnerError',
	LookupOwnerAddress: '[application] LookupOwnerAddress',
	DeletePreviousPropertyOwnerContacts: '[application] DeletePreviousPropertyOwnerContacts',
	Search: '[application] Search',

	SaveSearchQuery: '[application] SaveSearchQuery',
	SaveSearchQuerySuccess: '[application] SaveSearchQuerySuccess',
	SaveSearchQueryError: '[application] SaveSearchQueryError',
	GetAllSearchQueries: '[application] GetAllSearchQueries',
	GetAllSearchQueriesSuccess: '[application] GetAllSearchQueriesSuccess',
	GetAllSearchQueriesError: '[application] GetAllSearchQueriesError',
	RemoveSavedSearchQuery: '[application] RemoveSavedSearchQuery',
	RemoveSavedSearchQuerySuccess: '[application] RemoveSavedSearchQuerySuccess',
	RemoveSavedSearchQueryError: '[application] RemoveSavedSearchQueryError',

	SearchResults: '[application] SearchResults',
	SearchResultsSuccess: '[application] SearchResultsSuccess',
	SearchResultsError: '[application] SearchResultsError',
	UpdateURLParams: '[application] UpdateURLParams',
	UploadAttachments: '[application] UploadAttachments',
	UploadDocumentSuccess: '[application] UploadDocumentSuccess',
	UploadDocumentError: '[application] UploadDocumentError',
	GetProblemAttachments: '[application] GetProblemAttachments',
	GetProblemAttachmentsSuccess: '[application] GetProblemAttachmentsSuccess',
	GetProblemAttachmentsError: '[application] GetProblemAttachmentsError',
	GetProblemAttachmentsImages: '[application] GetProblemAttachmentsImages',
	GetProblemAttachmentsImagesPartialSuccess: '[application] GetProblemAttachmentsImagesPartialSuccess',
	GetProblemAttachmentsImagesError: '[application] GetProblemAttachmentsImagesError',
	RemoveProblemAttachments: '[application] RemoveProblemAttachments',
	RemoveProblemAttachmentsImages: '[application] RemoveProblemAttachmentsImages',
	SetProblemAttachmentsImages: '[application] SetProblemAttachmentsImages',
	SetProblemAttachmentsImagesNull: '[application] SetProblemAttachmentsImagesNull',
	UpdateAttachment: '[application] UpdateAttachment',
	GetNewCaseMenu: '[application] GetNewCaseMenu',
	SetNewCaseMenu: '[application] SetNewCaseMenu',
	SetNoProblems: '[application] SetNoProblems',
	SetCompleteTask: '[application] SetCompleteTask',
	SetCompleteTaskSuccess: '[application] SetCompleteTaskSuccess',
	SetCompleteTaskError: '[application] SetCompleteTaskError',
	GetCityworksTransferMap: '[application] GetCityworksTransferMap',
	SetCityworksTransferMap: '[application] SetCityworksTransferMap',
	TransferringToCityworks: '[application] TransferringToCityworks',
	CityworksTransferRequest: '[application] CityworksTransferRequest',
	CityworksTransferRequestSuccess: '[application] CityworksTransferRequestSuccess',
	CityworksTransferRequestError: '[application] CityworksTransferRequestError',
	CityworksRequestView: '[application] CityworksRequestView',
	CityworksRequestViewSuccess: '[application] CityworksRequestViewSuccess',
	CityworksRequestViewError: '[application] CityworksRequestViewError',
	ClearCityworksRequestView: '[application] ClearCityworksRequestView',
	CreatingCodeCase: '[application] CreatingCodeCase',
	SetInProgressActivity: '[application] SetInProgressActivity',
	SetInProgressMyTask: '[application] SetInProgressMyTask',
	ScrollToResults: '[application] ScrollToResults',
	GoToProblemDetails: '[application] GoToProblemDetails',
	SetAppView: '[application] SetAppView',
	SetViewLoading: '[application] SetViewLoading',
	AddWorkOrder: '[application] AddWorkOrder',
	AddWorkOrderSuccess: '[application] AddWorkOrderSuccess',
	AddWorkOrderError: '[application] AddWorkOrderError',
	SubmitWorkOrder: '[application] SubmitWorkOrder',
	SubmitWorkOrderSuccess: '[application] SubmitWorkOrderSuccess',
	SubmitWorkOrderError: '[application] SubmitWorkOrderError',
	DeleteWorkOrderByActivityId: '[application] DeleteWorkOrderByActivityId',
	DeleteWorkOrderByActivityIdSuccess: '[application] DeleteWorkOrderByActivityIdSuccess',
	DeleteWorkOrderByActivityIdError: '[application] DeleteWorkOrderByActivityIdError',
	UpdateProblemRead: '[application] UpdateProblemRead',

	GetAllProblemLinkedCases: '[application] GetAllProblemLinkedCases',
	GetSearchListLinkedCases: '[application] GetSearchListLinkedCases',
	GetProblemLinkedCases: '[application] GetProblemLinkedCases',
	GetProblemLinkedCasesSucccess: '[application] GetProblemLinkedCasesSuccess',
	GetProblemLinkedCasesError: '[application] GetProblemLinkedCasesError',
	GetProblemLinkedCasesAddMenu: '[application] GetProblemLinkedCasesAddMenu',
	GetProblemLinkedCasesAddMenuSucccess: '[application] GetProblemLinkedCasesAddMenuSuccess',
	GetProblemLinkedCasesAddMenuError: '[application] GetProblemLinkedCasesAddMenuError',
	AddProblemLinkedCase: '[application] AddProblemLinkedCase',
	AddProblemLinkedCases: '[application] AddProblemLinkedCases',
	AddProblemLinkedCaseSuccess: '[application] AddProblemLinkedCaseSuccess',
	AddProblemLinkedCaseSuccessToastMsg: '[application] AddProblemLinkedCaseSuccessToastMsg',
	AddProblemLinkedCaseError: '[application] AddProblemLinkedCaseError',
	UnlinkProblemCase: '[application] UnlinkProblemCase',
	UnlinkProblemCaseSuccess: '[application] UnlinkProblemCaseSuccess',
	UnlinkProblemCaseError: '[application] UnlinkProblemCaseError',
	UpdateLinkedCaseNotes: '[application] UpdateCaseNotes',
	UpdateLinkedCaseNotesSuccess: '[application] UpdateCaseNotesSuccess',
	UpdateLinkedCaseNotesError: '[application] UpdateCaseNotesError',
	RenewArcGisToken: '[application] RenewArcGisToken',
	RenewArcGisTokenSuccess: '[application] RenewArcGisTokenSuccess',
	RenewArcGisTokenError: '[application] RenewArcGisTokenError',
	IsNation: '[application] IsNation',
	GetIsAdminUser: '[application] GetIsAdminUser',
	SetIsAdminUser: '[application] SetIsAdminUser',
	GetUsers: '[application] GetUsers',
	SetUsers: '[application] SetUsers',
	UpdateUser: '[application] UpdateUser',
	UpdateUserSuccess: '[application] UpdateUserSuccess',
	UpdateUserError: '[application] UpdateUserError',
	SetAdminSection: '[application] SetAdminSection',
	GetProfilePicture: '[application] GetProfilePicture',
	SetProfilePicture: '[application] SetProfilePicture',
	GetGroups: '[application] GetGroups',
	SetGroups: '[application] SetGroups',
	GetRoles: '[application] GetRoles',
	SetRoles: '[application] SetRoles',
	UpdateGroup: '[application] UpdateGroup',
	UpdateGroupSuccess: '[application] UpdateGroupSuccess',
	UpdateGroupError: '[application] UpdateGroupError',
	UpdateRole: '[application] UpdateRole',
	UpdateRoleSuccess: '[application] UpdateRoleSuccess',
	UpdateRoleError: '[application] UpdateRoleError',
	AdminCreateNewUser: '[application] AdminCreateNewUser',
	AdminCreateNewGroup: '[application] AdminCreateNewGroup',
	AdminCreateNewRole: '[application] AdminCreateNewRole',
	SetADUsersList: '[application] SetADUsersList',
	GetADUsersList: '[application] GetADUsersList',
	GetRecentProblemsList: '[application] GetRecentProblemsList',
	GetRecentProblemsListSuccess: '[application] GetRecentProblemsListSuccess',
	GetRecentProblemsListError: '[application] GetRecentProblemsListError',
	SetRecentProblemsList: '[application] SetRecentProblemsList',
	DuplicateProblem: '[application] DuplicateProblem',
	DuplicateProblemSuccess: '[application] DuplicateProblemSuccess',
	DuplicateProblemError: '[application] DuplicateProblemError',
	CloseProblem: '[application] CloseProblem',
	CloseProblemSuccess: '[application] CloseProblemSuccess',
	CloseProblemError: '[application] CloseProblemError',
};

export interface WindowSize {
	windowInnerHeight: number;
	windowInnerWidth: number;
}

export class DownloadEdocsFile implements Action {
	public type: string = ApplicationActionType.DownloadEdocsFile;

	constructor(public payload?: number) {}
}

export class DownloadAzureFile implements Action {
	public type: string = ApplicationActionType.DownloadAzureFile;

	constructor(public payload?: string) {}
}

export class DelayedAction implements Action {
	public type: string = ApplicationActionType.DelayedAction;

	constructor(public payload?: Action[]) {}
}

export class DelayedActionBy1 implements Action {
	public type: string = ApplicationActionType.DelayedActionBy1;

	constructor(public payload?: Action[]) {}
}

export class DeleteAttachment implements Action {
	public type: string = ApplicationActionType.DeleteAttachment;

	constructor(public payload?: { attachmentId: number; caseNo: string }) {}
}

export class DeleteContact implements Action {
	public type: string = ApplicationActionType.DeleteContact;

	constructor(public payload?: ProblemContactsPayload) {}
}

export class DeleteContactSuccess implements Action {
	public type: string = ApplicationActionType.DeleteContactSuccess;

	constructor(public payload?: ProblemContactsPayload) {}
}

export class DeleteContactError implements Action {
	public type: string = ApplicationActionType.DeleteContactError;

	constructor(public payload?: ProblemContactsPayload) {}
}

export class DeletePhone implements Action {
	public type: string = ApplicationActionType.DeletePhone;

	constructor(public payload?: DeleteEntityPayload) {}
}

export class DeletePhoneSuccess implements Action {
	public type: string = ApplicationActionType.DeletePhoneSuccess;

	constructor(public payload?: DeleteEntityPayload) {}
}

export class DeletePhoneError implements Action {
	public type: string = ApplicationActionType.DeletePhoneError;

	constructor(public payload?: DeleteEntityPayload) {}
}

export class GetMenuOption implements Action {
	public type: string = ApplicationActionType.GetMenuOption;

	constructor(public payload?: GetMenuOptionPayload) {}
}

export class GetMenuOptionSuccess implements Action {
	public type: string = ApplicationActionType.GetMenuOptionSuccess;

	constructor(public payload?: GetMenuOptionPayload) {}
}

export class GetMenuOptionError implements Action {
	public type: string = ApplicationActionType.GetMenuOptionError;

	constructor(public payload?: GetMenuOptionPayload) {}
}

export class Idle implements Action {
	public type: string = ApplicationActionType.Idle;

	constructor(public payload?: any) {}
}

export class Layer implements Action {
	public type: string = ApplicationActionType.Layer;

	constructor(public payload?: any) {}
}

export class GetLayers implements Action {
	public type: string = ApplicationActionType.GetLayers;

	constructor(public payload?: any) {}
}

export class CheckLayerDisplay implements Action {
	public type: string = ApplicationActionType.CheckLayerDisplay;

	constructor(public payload?: any) {}
}

export class SetProblemNeighborScope implements Action {
	public type: string = ApplicationActionType.SetProblemNeighborScope;
	constructor(public payload?: ProblemNeighborScope) {}
}

export class SetProblemNeighborScopeSuccess implements Action {
	public type: string = ApplicationActionType.SetProblemNeighborScopeSuccess;
	constructor(public payload?: ProblemNeighborScope) {}
}

export class GetProblemNeighbors implements Action {
	public type: string = ApplicationActionType.GetProblemNeighbors;
	constructor(public payload?: ProblemNeighborPayload) {}
}

export class GetProblemNeighborsSuccess implements Action {
	public type: string = ApplicationActionType.GetProblemNeighborsSuccess;
	constructor(public payload?: ProblemNeighborPayload) {}
}

export class GetProblems implements Action {
	public type: string = ApplicationActionType.GetProblems;

	constructor(public payload?: GetProblemsPayload) {}
}

export class GetProblemsSuccess implements Action {
	public type: string = ApplicationActionType.GetProblemsSuccess;

	constructor(public payload?: GetProblemsPayload) {}
}

export class GetProblemsError implements Action {
	public type: string = ApplicationActionType.GetProblemsError;

	constructor(public payload?: GetProblemsPayload) {}
}

export class GetDashBoardProblems implements Action {
	public type: string = ApplicationActionType.GetDashBoardProblems;

	constructor(public payload?: GetProblemsPayload) {}
}

export class GetDashBoardProblemsSuccess implements Action {
	public type: string = ApplicationActionType.GetDashBoardProblemsSuccess;

	constructor(public payload?: GetProblemsPayload) {}
}

export class GetDashBoardProblemsError implements Action {
	public type: string = ApplicationActionType.GetDashBoardProblemsError;

	constructor(public payload?: GetProblemsPayload) {}
}

export class Heartbeat implements Action {
	public type: string = ApplicationActionType.Heartbeat;

	constructor(public payload?: HeartbeatPayload) {}
}

export class HeartbeatSuccess implements Action {
	public type: string = ApplicationActionType.HeartbeatSuccess;

	constructor(public payload?: HeartbeatPayload) {}
}

export class HeartbeatError implements Action {
	public type: string = ApplicationActionType.HeartbeatError;

	constructor(public payload?: HeartbeatPayload) {}
}

export class SetMenuOption implements Action {
	public type: string = ApplicationActionType.SetMenuOption;

	constructor(public payload?: MenuItem) {}
}

export class SetMenuDictionaries implements Action {
	public type: string = ApplicationActionType.SetMenuDictionaries;

	constructor(public payload?: MenuItem) {}
}

export class SetRapUsers implements Action {
	public type: string = ApplicationActionType.SetRapUsers;

	constructor(public payload?: any) {}
}

export class GetProblemContacts implements Action {
	public type: string = ApplicationActionType.GetProblemContacts;

	constructor(public payload?: GetContactsPayload) {}
}

export class GetProblemContactsSuccess implements Action {
	public type: string = ApplicationActionType.GetProblemContactsSuccess;

	constructor(public payload?: GetContactsPayload) {}
}

export class GetProblemContactsError implements Action {
	public type: string = ApplicationActionType.GetProblemContactsError;

	constructor(public payload?: GetContactsPayload) {}
}

export class AddProblemContacts implements Action {
	public type: string = ApplicationActionType.AddProblemContacts;

	constructor(public payload?: ProblemContactsPayload) {}
}

export class AddProblemContactsSuccess implements Action {
	public type: string = ApplicationActionType.AddProblemContactsSuccess;

	constructor(public payload?: ProblemContactsPayload) {}
}

export class AddProblemContactsError implements Action {
	public type: string = ApplicationActionType.AddProblemContactsError;

	constructor(public payload?: ProblemContactsPayload) {}
}

export class SetProblems implements Action {
	public type: string = ApplicationActionType.SetProblems;

	constructor(public payload?: Problem[]) {}
}

export class SetDashBoardProblems implements Action {
	public type: string = ApplicationActionType.SetDashBoardProblems;

	constructor(public payload?: string[]) {}
}

export class SetProblemsFiltered implements Action {
	public type: string = ApplicationActionType.SetProblemsFiltered;

	constructor(public payload?: Problem[]) {}
}

export class SelectProblem implements Action {
	type = ApplicationActionType.SelectProblem;

	constructor(public payload?: string) {}
}

export class SetProblemMarkers implements Action {
	public type: string = ApplicationActionType.SetProblemMarkers;

	constructor(public payload?: { problem: Problem[]; showToolTip: boolean }) {}
}

export class SetDashboardView implements Action {
	public type: string = ApplicationActionType.SetDashboardView;

	constructor(public payload?: string) {}
}

export class ToggleCategoryExpanded implements Action {
	public type: string = ApplicationActionType.ToggleCategoryExpanded;
	constructor(public payload?: string) {}
}

// export class ToggleProblemExpanded implements Action {
//   public type: string = ApplicationActionType.ToggleProblemExpanded;
//   constructor(public payload?: string) { }
// }

export class SetNoMapLocation implements Action {
	public type: string = ApplicationActionType.SetNoMapLocation;

	constructor(public payload?: boolean) {}
}

export class UpdateWindowSize implements Action {
	public type: string = ApplicationActionType.UpdateWindowSize;

	constructor(public payload?: WindowSize) {}
}

export class GetActivity implements Action {
	public type: string = ApplicationActionType.GetActivity;

	constructor(public payload?: string) {}
}

export class GetActivities implements Action {
	public type: string = ApplicationActionType.GetActivities;

	constructor(public payload?: string) {}
}

export class GetAsset implements Action {
	public type: string = ApplicationActionType.GetAsset;

	constructor(public payload?: string) {}
}

export class SetCompleteTask implements Action {
	public type: string = ApplicationActionType.SetCompleteTask;

	constructor(public payload?: number) {}
}

export class SetCompleteTaskSuccess implements Action {
	public type: string = ApplicationActionType.SetCompleteTaskSuccess;

	constructor(public payload?: TaskPayload) {}
}

export class SetCompleteTaskError implements Action {
	public type: string = ApplicationActionType.SetCompleteTaskError;

	constructor(public payload?: TaskPayload) {}
}

// export class SetActivity implements Action {
//   public type: string = ApplicationActionType.SetActivity;

//   constructor(public payload?: ActivityList) { }
// }

export class SetAccess implements Action {
	public type: string = ApplicationActionType.SetAccess;

	constructor(public payload?: boolean) {}
}

export class SetActivities implements Action {
	public type: string = ApplicationActionType.SetActivities;

	constructor(public payload?: ActivityList[]) {}
}

export class SetAsset implements Action {
	public type: string = ApplicationActionType.SetAsset;

	constructor(public payload?: Asset[]) {}
}

export class SetTasks implements Action {
	public type: string = ApplicationActionType.SetTasks;

	constructor(public payload?: TaskList[]) {}
}

export class SetNewCaseNo implements Action {
	public type: string = ApplicationActionType.SetNewCaseNo;

	constructor(public payload?: { caseNo: string; department: string; user: string }) {}
}

export class SetDashboardTabView implements Action {
	public type: string = ApplicationActionType.SetDashboardTabView;

	constructor(public payload?: DashboardTabView) {}
}

export class AddActivity implements Action {
	public type: string = ApplicationActionType.AddActivity;

	constructor(public payload?: AddActivityPayload) {}
}

export class AddActivitySuccess implements Action {
	public type: string = ApplicationActionType.AddActivitySuccess;

	constructor(public payload?: AddActivityPayload) {}
}

export class AddActivityError implements Action {
	public type: string = ApplicationActionType.AddActivityError;

	constructor(public payload?: AddActivityPayload) {}
}

export class GetDashboardView implements Action {
	public type: string = ApplicationActionType.GetDashboardView;

	constructor(public payload?: string) {}
}

export class GetDashboardViewSuccess implements Action {
	public type: string = ApplicationActionType.GetDashboardViewSuccess;

	constructor(public payload?: string) {}
}

export class GetDashboardViewError implements Action {
	public type: string = ApplicationActionType.GetDashboardViewError;

	constructor(public payload?: string) {}
}

export class SaveDashboardView implements Action {
	public type: string = ApplicationActionType.SaveDashboardView;

	constructor(public payload?: string) {}
}

export class SaveDashboardViewSuccess implements Action {
	public type: string = ApplicationActionType.SaveDashboardViewSuccess;

	constructor(public payload?: string) {}
}

export class SaveDashboardViewError implements Action {
	public type: string = ApplicationActionType.SaveDashboardViewError;

	constructor(public payload?: string) {}
}

export class AddAsset implements Action {
	public type: string = ApplicationActionType.AddAsset;

	constructor(public payload?: AssetPayload) {}
}

export class AddAssetSuccess implements Action {
	public type: string = ApplicationActionType.AddAssetSuccess;

	constructor(public payload?: AssetPayload) {}
}

export class AddAssetError implements Action {
	public type: string = ApplicationActionType.AddAssetError;

	constructor(public payload?: AssetPayload) {}
}

export class DeleteAsset implements Action {
	public type: string = ApplicationActionType.DeleteAsset;

	constructor(public payload?: AssetPayload) {}
}

export class DeleteAssetSuccess implements Action {
	public type: string = ApplicationActionType.DeleteAssetSuccess;

	constructor(public payload?: AssetPayload) {}
}

export class DeleteAssetError implements Action {
	public type: string = ApplicationActionType.DeleteAssetError;

	constructor(public payload?: AssetPayload) {}
}

export class AddCodeCase implements Action {
	public type: string = ApplicationActionType.AddCodeCase;

	constructor(public payload?: ProblemCodeCasePayload) {}
}

export class AddCodeCaseSuccess implements Action {
	public type: string = ApplicationActionType.AddCodeCaseSuccess;

	constructor(public payload?: LinkedCase) {}
}

export class AddCodeCaseError implements Action {
	public type: string = ApplicationActionType.AddCodeCaseError;

	constructor(public payload?: ProblemCodeCasePayload) {}
}

export class AddPermit implements Action {
	public type: string = ApplicationActionType.AddPermit;

	constructor(public payload?: ProblemCodeCasePayload) {}
}

export class AddPermitSuccess implements Action {
	public type: string = ApplicationActionType.AddPermitSuccess;

	constructor(public payload?: LinkedCase) {}
}

export class AddPermitError implements Action {
	public type: string = ApplicationActionType.AddPermitError;

	constructor(public payload?: ProblemCodeCasePayload) {}
}

export class AddProblem implements Action {
	public type: string = ApplicationActionType.AddProblem;

	constructor(public payload?: ProblemDB) {}
}
export class CancelActivity implements Action {
	public type: string = ApplicationActionType.CancelActivity;
	constructor(public payload?: CancelActivityPayload) {}
}
export class CancelActivitySuccess implements Action {
	public type: string = ApplicationActionType.CancelActivitySuccess;
	constructor(public payload?: ActivityList[]) {}
}
export class CancelActivityError implements Action {
	public type: string = ApplicationActionType.CancelActivityError;
	constructor(public payload?: CancelActivityPayload) {}
}
export class UpdateActivityClose implements Action {
	public type: string = ApplicationActionType.UpdateActivityClose;

	constructor(public payload?: UpdateActivityDetails) {}
}
export class UpdateActivity implements Action {
	public type: string = ApplicationActionType.UpdateActivity;

	constructor(public payload?: UpdateActivityDetails) {}
}

export class UpdateActivitySuccess implements Action {
	public type: string = ApplicationActionType.UpdateActivitySuccess;

	constructor(public payload?: UpdateActivityDetails) {}
}

export class UpdateActivityError implements Action {
	public type: string = ApplicationActionType.UpdateActivityError;

	constructor(public payload?: UpdateActivityDetails) {}
}

/* export class GetCategorySubType implements Action {
  public type: string = ApplicationActionType.GetCategorySubType;

  constructor(public payload?: string) { }
} */

export class SetCategorySubType implements Action {
	public type: string = ApplicationActionType.SetCategorySubType;

	constructor(public payload?: ProblemCategorySubType[]) {}
}

export class AddCaseGotoStep implements Action {
	public type: string = ApplicationActionType.AddCaseGotoStep;

	constructor(public payload?: number) {}
}

export class SetSelectedProblemType implements Action {
	public type: string = ApplicationActionType.SetSelectedProblemType;

	constructor(public payload?: ProblemSubType) {}
}

export class GetAllProblemSubTypes implements Action {
	public type: string = ApplicationActionType.GetAllProblemSubTypes;
	constructor(public payload: any) {}
}

export class SetAllProblemSubTypes implements Action {
	public type: string = ApplicationActionType.SetAllProblemSubTypes;
	constructor(public payload?: SelectedProblemSubType[]) {}
}

export class ReassignProblem implements Action {
	public type: string = ApplicationActionType.ReassignProblem;

	constructor(public payload?: ReassignProblemPayload) {}
}

export class ReassignProblemSuccess implements Action {
	public type: string = ApplicationActionType.ReassignProblemSuccess;

	constructor(public payload?: ReassignProblemPayload) {}
}

export class ReassignProblemError implements Action {
	public type: string = ApplicationActionType.ReassignProblemError;

	constructor(public payload?: ReassignProblemPayload) {}
}

/* export class ReassignGroupProblem implements Action {
  public type: string = ApplicationActionType.ReassignGroupProblem;

  constructor(public payload?: ReassignGroup) { }
}

export class ReassignGroupProblemSuccess implements Action {
  public type: string = ApplicationActionType.ReassignGroupProblemSuccess;

  constructor(public payload?: ReassignGroup) { }
}

export class ReassignGroupProblemError implements Action {
  public type: string = ApplicationActionType.ReassignGroupProblemError;

  constructor(public payload?: ReassignGroup) { }
} */

export class ToastUserNotification implements Action {
	public type: string = ApplicationActionType.ToastUserNotification;
	constructor(public payload?: UserNotification) {}
}

export class RedirectPath implements Action {
	public type: string = ApplicationActionType.RedirectPath;
	constructor(public payload?: string[]) {}
}

export class GetProblemHistory implements Action {
	public type: string = ApplicationActionType.GetProblemHistory;
	constructor(public payload?: string) {}
}

export class GetProblemHistorySuccess implements Action {
	public type: string = ApplicationActionType.GetProblemHistorySuccess;
	constructor(public payload?: History[]) {}
}

export class GetProblemHistoryError implements Action {
	public type: string = ApplicationActionType.GetProblemHistoryError;
	constructor(public payload?: string) {}
}

export class UpdateProblem implements Action {
	public type: string = ApplicationActionType.UpdateProblem;
	constructor(public payload?: { problemId: number; resolution?: ''; problem: NewProblem }) {}
}

export class GetDescriptionHistory implements Action {
	public type: string = ApplicationActionType.GetDescriptionHistory;
	constructor(public payload?: string) {}
}

export class SetDescriptionHistory implements Action {
	public type: string = ApplicationActionType.SetDescriptionHistory;
	constructor(public payload?: History[]) {}
}

export class SetProblemContacts implements Action {
	public type: string = ApplicationActionType.SetProblemContacts;
	constructor(public payload?: ProblemContact[]) {}
}

export class UpdateContact implements Action {
	public type: string = ApplicationActionType.UpdateContact;
	constructor(public payload?: { contact: ProblemContact; problemNo: string }) {}
}

export class SetZoneLookupOnly implements Action {
	public type: string = ApplicationActionType.SetZoneLookupOnly;
	constructor(public payload?: boolean) {}
}

export class SetSearchCoordinates implements Action {
	public type: string = ApplicationActionType.SetSearchCoordinates;
	constructor(public payload?: SearchCoordinatesPayload) {}
}

export class SearchCoordinates implements Action {
	public type: string = ApplicationActionType.SearchCoordinates;
	constructor(public payload?: SearchCoordinatesPayload) {}
}

export class SearchCoordinatesSuccess implements Action {
	public type: string = ApplicationActionType.SearchCoordinatesSuccess;
	constructor(public payload?: SearchCoordinatesPayload) {}
}

export class SearchCoordinatesError implements Action {
	public type: string = ApplicationActionType.SearchCoordinatesError;
	constructor(public payload?: SearchCoordinatesPayload) {}
}

export class SearchFromCoordinates implements Action {
	public type: string = ApplicationActionType.SearchFromCoordinates;
	constructor(public payload?: SearchFromCoordinatesPayload) {}
}

export class SearchFromCoordinatesSuccess implements Action {
	public type: string = ApplicationActionType.SearchFromCoordinatesSuccess;
	constructor(public payload?: SearchFromCoordinatesPayload) {}
}

export class SearchFromCoordinatesError implements Action {
	public type: string = ApplicationActionType.SearchFromCoordinatesError;
	constructor(public payload?: SearchFromCoordinatesPayload) {}
}

export class LookupOwner implements Action {
	public type: string = ApplicationActionType.LookupOwner;
	constructor(public payload?: LookupOwnerPayload) {}
}

export class LookupOwnerSuccess implements Action {
	public type: string = ApplicationActionType.LookupOwnerSuccess;
	constructor(public payload?: LookupOwnerPayload) {}
}

export class LookupOwnerReset implements Action {
	public type: string = ApplicationActionType.LookupOwnerReset;
	constructor(public payload?: any) {}
}

export class LookupOwnerError implements Action {
	public type: string = ApplicationActionType.LookupOwnerError;
	constructor(public payload?: LookupOwnerPayload) {}
}

export class LookupOwnerAddress implements Action {
	public type: string = ApplicationActionType.LookupOwnerAddress;
	constructor(public payload?: LookupOwnerPayload) {}
}

export class DeletePreviousPropertyOwnerContacts implements Action {
	public type: string = ApplicationActionType.DeletePreviousPropertyOwnerContacts;
	constructor(public payload?: any) {}
}

export class Search implements Action {
	public type: string = ApplicationActionType.Search;
	constructor(public payload?: SearchResultsPayload) {}
}

export class SaveSearchQuery implements Action {
	public type: string = ApplicationActionType.SaveSearchQuery;
	constructor(public payload?: SaveSearchQueryPayload) {}
}

export class SaveSearchQuerySuccess implements Action {
	public type: string = ApplicationActionType.SaveSearchQuerySuccess;
	constructor(public payload?: SaveSearchQueryPayload) {}
}

export class SaveSearchQueryError implements Action {
	public type: string = ApplicationActionType.SaveSearchQueryError;
	constructor(public payload?: SaveSearchQueryPayload) {}
}

export class GetAllSearchQueries implements Action {
	public type: string = ApplicationActionType.GetAllSearchQueries;
	constructor() {}
}

export class GetAllSearchQueriesSuccess implements Action {
	public type: string = ApplicationActionType.GetAllSearchQueriesSuccess;
	constructor(public payload?: SearchQuery) {}
}

export class GetAllSearchQueriesError implements Action {
	public type: string = ApplicationActionType.GetAllSearchQueriesError;
	constructor() {}
}

export class RemoveSavedSearchQuery implements Action {
	public type: string = ApplicationActionType.RemoveSavedSearchQuery;
	constructor(public payload?: SearchQuery) {}
}

export class RemoveSavedSearchQuerySuccess implements Action {
	public type: string = ApplicationActionType.RemoveSavedSearchQuerySuccess;
	constructor(public payload?: SearchQuery) {}
}

export class RemoveSavedSearchQueryError implements Action {
	public type: string = ApplicationActionType.RemoveSavedSearchQueryError;
	constructor(public payload?: SearchQuery) {}
}

export class SearchResults implements Action {
	public type: string = ApplicationActionType.SearchResults;
	constructor(public payload?: SearchResultsPayload) {}
}

export class SearchResultsSuccess implements Action {
	public type: string = ApplicationActionType.SearchResultsSuccess;
	constructor(public payload?: SearchResultsPayload) {}
}

export class SearchResultsError implements Action {
	public type: string = ApplicationActionType.SearchResultsError;
	constructor(public payload?: SearchResultsPayload) {}
}

export class UpdateURLParams implements Action {
	public type: string = ApplicationActionType.UpdateURLParams;
	constructor(public payload?: SearchResultsPayload) {}
}

export class UploadAttachments implements Action {
	public type: string = ApplicationActionType.UploadAttachments;
	constructor(public payload?: UploadAttachmentsPayload) {}
}

export class UploadDocumentSuccess implements Action {
	public type: string = ApplicationActionType.UploadDocumentSuccess;
	constructor(public payload?: UploadAttachmentsPayload) {}
}

export class UploadDocumentError implements Action {
	public type: string = ApplicationActionType.UploadDocumentError;
	constructor(public payload?: UploadAttachmentsPayload) {}
}

export class GetProblemAttachments implements Action {
	public type: string = ApplicationActionType.GetProblemAttachments;
	constructor(public payload?: string) {}
}

export class GetProblemAttachmentsSuccess implements Action {
	public type: string = ApplicationActionType.GetProblemAttachmentsSuccess;
	constructor(public payload?: Attachment[]) {}
}

export class GetProblemAttachmentsError implements Action {
	public type: string = ApplicationActionType.GetProblemAttachmentsError;
	constructor(public payload?: string) {}
}

export class GetProblemAttachmentsImages implements Action {
	public type: string = ApplicationActionType.GetProblemAttachmentsImages;
	constructor(public payload?: { caseNo: string; docNumbers: string[] }) {}
}

export class GetProblemAttachmentsImagesPartialSuccess implements Action {
	public type: string = ApplicationActionType.GetProblemAttachmentsImagesPartialSuccess;
	constructor(public payload?: string) {}
}

export class GetProblemAttachmentsImagesError implements Action {
	public type: string = ApplicationActionType.GetProblemAttachmentsImagesError;
	constructor(public payload?: string) {}
}

export class RemoveProblemAttachments implements Action {
	public type: string = ApplicationActionType.RemoveProblemAttachments;
	constructor(public payload?: string) {}
}

export class RemoveProblemAttachmentsImages implements Action {
	public type: string = ApplicationActionType.RemoveProblemAttachmentsImages;
	constructor(public payload?: string) {}
}

export class SetProblemAttachmentsImages implements Action {
	public type: string = ApplicationActionType.SetProblemAttachmentsImages;
	constructor(public payload?: NgxGalleryImage[]) {}
}

export class SetProblemAttachmentsImagesNull implements Action {
	public type: string = ApplicationActionType.SetProblemAttachmentsImagesNull;
	constructor(public payload?: NgxGalleryImage[]) {}
}

export class UpdateAttachment implements Action {
	public type: string = ApplicationActionType.UpdateAttachment;

	constructor(public payload?: UpdateAttachmentDetails) {}
}

export class GetNewCaseMenu implements Action {
	public type: string = ApplicationActionType.GetNewCaseMenu;

	constructor(public payload?: GetNewCaseMenu) {}
}

export class SetNewCaseMenu implements Action {
	public type: string = ApplicationActionType.SetNewCaseMenu;

	constructor(public payload?: ProblemMenuConfig[]) {}
}

export class SetNoProblems implements Action {
	public type: string = ApplicationActionType.SetNoProblems;

	constructor(public payload?: boolean) {}
}

export class GetTask implements Action {
	public type: string = ApplicationActionType.GetTask;

	constructor(public payload?: TaskPayload) {}
}

export class GetTasks implements Action {
	public type: string = ApplicationActionType.GetTasks;

	constructor(public payload?: TaskPayload) {}
}

export class GetTaskSuccess implements Action {
	public type: string = ApplicationActionType.GetTaskSuccess;

	constructor(public payload?: TaskPayload) {}
}

export class GetTaskError implements Action {
	public type: string = ApplicationActionType.GetTaskError;

	constructor(public payload?: TaskPayload) {}
}

export class GetCityworksTransferMap implements Action {
	public type: string = ApplicationActionType.GetCityworksTransferMap;
	constructor(public payload?: any) {}
}

export class SetCityworksTransferMap implements Action {
	public type: string = ApplicationActionType.SetCityworksTransferMap;
	constructor(public payload: CityworksTransferMapping[]) {}
}

export class TransferringToCityworks implements Action {
	public type: string = ApplicationActionType.TransferringToCityworks;
	constructor(public payload?: boolean) {}
}

export class CityworksTransferRequest implements Action {
	public type: string = ApplicationActionType.CityworksTransferRequest;
	constructor(public payload?: { caseNo: string; originalCaseNo?: string }) {}
}

export class CityworksTransferRequestSuccess implements Action {
	public type: string = ApplicationActionType.CityworksTransferRequestSuccess;
	constructor(public payload?: any) {}
}

export class CityworksTransferRequestError implements Action {
	public type: string = ApplicationActionType.CityworksTransferRequestError;
	constructor(public payload?: any) {}
}

export class CityworksRequestView implements Action {
	public type: string = ApplicationActionType.CityworksRequestView;
	constructor(public payload: number) {}
}

export class CityworksRequestViewSuccess implements Action {
	public type: string = ApplicationActionType.CityworksRequestViewSuccess;
	constructor(public payload: CityWorksRequestViewResponse) {}
}

export class CityworksRequestViewError implements Action {
	public type: string = ApplicationActionType.CityworksRequestViewError;
	constructor(public payload?: any) {}
}

export class ClearCityworksRequestView implements Action {
	public type: string = ApplicationActionType.ClearCityworksRequestView;
	constructor(public payload?: any) {}
}

export class CreatingCodeCase implements Action {
	public type: string = ApplicationActionType.CreatingCodeCase;

	constructor(public payload?: boolean) {}
}
export class SetInProgressActivity implements Action {
	public type: string = ApplicationActionType.SetInProgressActivity;

	constructor(public payload?: boolean) {}
}

export class SetInProgressMyTask implements Action {
	public type: string = ApplicationActionType.SetInProgressMyTask;

	constructor(public payload?: boolean) {}
}

export class ScrollToResults implements Action {
	public type: string = ApplicationActionType.ScrollToResults;

	constructor(public payload?: boolean) {}
}

export class GoToProblemDetails implements Action {
	public type: string = ApplicationActionType.GoToProblemDetails;

	constructor(public payload?: { problemNo: string; activityNo: string }) {}
}

export class SetAppView implements Action {
	public type: string = ApplicationActionType.SetAppView;

	constructor(public payload?: string) {}
}

export class SetViewLoading implements Action {
	public type: string = ApplicationActionType.SetViewLoading;

	constructor(public payload?: boolean) {}
}

export class AddWorkOrder implements Action {
	public type: string = ApplicationActionType.AddWorkOrder;

	constructor(public payload?: AddWorkOrderPayload) {}
}

export class AddWorkOrderSuccess implements Action {
	public type: string = ApplicationActionType.AddWorkOrderSuccess;

	constructor(public payload?: AddWorkOrderPayload) {}
}

export class AddWorkOrderError implements Action {
	public type: string = ApplicationActionType.AddWorkOrderError;

	constructor(public payload?: AddWorkOrderPayload) {}
}

export class SubmitWorkOrder implements Action {
	public type: string = ApplicationActionType.SubmitWorkOrder;

	constructor(public payload?: SubmitWorkOrderPayload) {}
}

export class SubmitWorkOrderSuccess implements Action {
	public type: string = ApplicationActionType.SubmitWorkOrderSuccess;

	constructor(public payload?: SubmitWorkOrderPayload) {}
}

export class SubmitWorkOrderError implements Action {
	public type: string = ApplicationActionType.SubmitWorkOrderError;

	constructor(public payload?: SubmitWorkOrderPayload) {}
}

export class DeleteWorkOrderByActivityId implements Action {
	public type: string = ApplicationActionType.DeleteWorkOrderByActivityId;

	constructor(public payload?: DeleteWorkOrderPayload) {}
}

export class DeleteWorkOrderByActivityIdSuccess implements Action {
	public type: string = ApplicationActionType.DeleteWorkOrderByActivityIdSuccess;

	constructor(public payload?: DeleteWorkOrderPayload) {}
}

export class DeleteWorkOrderByActivityIdError implements Action {
	public type: string = ApplicationActionType.DeleteWorkOrderByActivityIdError;

	constructor(public payload?: DeleteWorkOrderPayload) {}
}

export class UpdateProblemRead implements Action {
	public type: string = ApplicationActionType.UpdateProblemRead;

	constructor(public payload?: string) {}
}

export class GetAllProblemLinkedCases implements Action {
	public type: string = ApplicationActionType.GetAllProblemLinkedCases;
	constructor(public payload?: any) {}
}

export class GetSearchListLinkedCases implements Action {
	public type: string = ApplicationActionType.GetSearchListLinkedCases;
	constructor(public payload: string[]) {}
}

export class GetProblemLinkedCases implements Action {
	public type: string = ApplicationActionType.GetProblemLinkedCases;
	constructor(public payload?: any) {}
}

export class GetProblemLinkedCasesSucccess implements Action {
	public type: string = ApplicationActionType.GetProblemLinkedCasesSucccess;
	constructor(public payload?: LinkedCase[]) {}
}

export class GetProblemLinkedCasesError implements Action {
	public type: string = ApplicationActionType.GetProblemLinkedCasesError;
	constructor(public payload?: any) {}
}

export class GetProblemLinkedCasesAddMenu implements Action {
	public type: string = ApplicationActionType.GetProblemLinkedCasesAddMenu;
	constructor(public payload?: any) {}
}

export class GetProblemLinkedCasesAddMenuSucccess implements Action {
	public type: string = ApplicationActionType.GetProblemLinkedCasesAddMenuSucccess;
	constructor(public payload?: LinkedCaseRelated) {}
}

export class GetProblemLinkedCasesAddMenuError implements Action {
	public type: string = ApplicationActionType.GetProblemLinkedCasesAddMenuError;
	constructor(public payload?: any) {}
}

export class AddProblemLinkedCases implements Action {
	public type: string = ApplicationActionType.AddProblemLinkedCases;
	constructor(public payload?: LinkedCasePayload[]) {}
}

export class AddProblemLinkedCase implements Action {
	public type: string = ApplicationActionType.AddProblemLinkedCase;
	constructor(public payload?: FromProblemLinkedCasePayload) {}
}

export class AddProblemLinkedCaseSuccess implements Action {
	public type: string = ApplicationActionType.AddProblemLinkedCaseSuccess;
	constructor(public payload?: { caseNo?: string; linkedCase: LinkedCase[] }) {}
}

export class AddProblemLinkedCaseSuccessToastMsg implements Action {
	public type: string = ApplicationActionType.AddProblemLinkedCaseSuccessToastMsg;
	constructor(public payload?: { caseNo?: string; msg: string }) {}
}

export class AddProblemLinkedCaseError implements Action {
	public type: string = ApplicationActionType.AddProblemLinkedCaseError;
	constructor(public payload?: any) {}
}

export class UnlinkProblemCase implements Action {
	public type: string = ApplicationActionType.UnlinkProblemCase;
	constructor(public payload?: UnlinkProblemCasePayload) {}
}

export class UnlinkProblemCaseSuccess implements Action {
	public type: string = ApplicationActionType.UnlinkProblemCaseSuccess;
	constructor(public payload?: LinkedCase[]) {}
}

export class UnlinkProblemCaseError implements Action {
	public type: string = ApplicationActionType.UnlinkProblemCaseError;
	constructor(public payload?: UnlinkProblemCasePayload) {}
}

export class UpdateLinkedCaseNotes implements Action {
	public type: string = ApplicationActionType.UpdateLinkedCaseNotes;
	constructor(public payload?: UpdateLinkedCasePayload) {}
}

export class UpdateLinkedCaseNotesSuccess implements Action {
	public type: string = ApplicationActionType.UpdateLinkedCaseNotesSuccess;
	constructor(public payload?: LinkedCase) {}
}

export class UpdateLinkedCaseNotesError implements Action {
	public type: string = ApplicationActionType.UpdateLinkedCaseNotesError;
	constructor(public payload?: UpdateLinkedCasePayload) {}
}

export class RenewArcGisToken implements Action {
	public type: string = ApplicationActionType.RenewArcGisToken;

	constructor(public payload?: RenewArcGisTokenPayload) {}
}

export class RenewArcGisTokenSuccess implements Action {
	public type: string = ApplicationActionType.RenewArcGisTokenSuccess;

	constructor(public payload?: RenewArcGisTokenPayload) {}
}

export class RenewArcGisTokenError implements Action {
	public type: string = ApplicationActionType.RenewArcGisTokenError;

	constructor(public payload?: RenewArcGisTokenPayload) {}
}

export class IsNation implements Action {
	public type: string = ApplicationActionType.IsNation;

	constructor(public payload?: string) {}
}

export class GetIsAdminUser implements Action {
	public type: string = ApplicationActionType.GetIsAdminUser;

	constructor(public payload?: any) {}
}

export class SetIsAdminUser implements Action {
	public type: string = ApplicationActionType.SetIsAdminUser;

	constructor(public payload: boolean) {}
}

export class GetUsers implements Action {
	public type: string = ApplicationActionType.GetUsers;

	constructor(public payload?: any) {}
}

export class SetUsers implements Action {
	public type: string = ApplicationActionType.SetUsers;

	constructor(public payload: any) {}
}

export class UpdateUser implements Action {
	public type: string = ApplicationActionType.UpdateUser;

	constructor(public payload: AdminUserView) {}
}

export class UpdateUserSuccess implements Action {
	public type: string = ApplicationActionType.UpdateUserSuccess;

	constructor(public payload: any) {}
}

export class UpdateUserError implements Action {
	public type: string = ApplicationActionType.UpdateUserError;

	constructor(public payload: any) {}
}

export class SetAdminSection implements Action {
	public type: string = ApplicationActionType.SetAdminSection;

	constructor(public payload: any) {}
}

export class GetProfilePicture implements Action {
	public type: string = ApplicationActionType.GetProfilePicture;
	constructor(public payload: any = null) {}
}

export class SetProfilePicture implements Action {
	public type: string = ApplicationActionType.SetProfilePicture;
	constructor(public payload: Blob | null) {}
}

export class AdminCreateNewUser implements Action {
	public type: string = ApplicationActionType.AdminCreateNewUser;
	constructor(public payload: AdminUserView) {}
}

export class GetGroups implements Action {
	public type: string = ApplicationActionType.GetGroups;

	constructor(public payload?: any) {}
}

export class SetGroups implements Action {
	public type: string = ApplicationActionType.SetGroups;
	constructor(public payload: Group[]) {}
}

export class GetRoles implements Action {
	public type: string = ApplicationActionType.GetRoles;

	constructor(public payload?: any) {}
}

export class SetRoles implements Action {
	public type: string = ApplicationActionType.SetRoles;
	constructor(public payload: Role[]) {}
}

export class UpdateGroup implements Action {
	public type: string = ApplicationActionType.UpdateGroup;

	constructor(public payload: any) {}
}

export class UpdateGroupSuccess implements Action {
	public type: string = ApplicationActionType.UpdateGroupSuccess;

	constructor(public payload: any) {}
}

export class UpdateGroupError implements Action {
	public type: string = ApplicationActionType.UpdateGroupError;

	constructor(public payload: any) {}
}

export class UpdateRole implements Action {
	public type: string = ApplicationActionType.UpdateRole;

	constructor(public payload: any) {}
}

export class UpdateRoleSuccess implements Action {
	public type: string = ApplicationActionType.UpdateRoleSuccess;

	constructor(public payload: any) {}
}

export class UpdateRoleError implements Action {
	public type: string = ApplicationActionType.UpdateRoleError;

	constructor(public payload: any) {}
}

export class AdminCreateNewGroup implements Action {
	public type: string = ApplicationActionType.AdminCreateNewGroup;
	constructor(public payload: any) {}
}

export class AdminCreateNewRole implements Action {
	public type: string = ApplicationActionType.AdminCreateNewRole;
	constructor(public payload: any) {}
}

export class GetADUsersList implements Action {
	public type: string = ApplicationActionType.GetADUsersList;
	constructor(public payload?: any) {}
}

export class SetADUsersList implements Action {
	public type: string = ApplicationActionType.SetADUsersList;
	constructor(public payload: AdminUserView[]) {}
}

export class GetRecentProblemsList implements Action {
	public type: string = ApplicationActionType.GetRecentProblemsList;
	constructor(public payload: any = null) {}
}

export class GetRecentProblemsListSuccess implements Action {
	public type: string = ApplicationActionType.GetRecentProblemsListSuccess;
	constructor(public payload?: Problem[]) {}
}

export class GetRecentProblemsListError implements Action {
	public type: string = ApplicationActionType.GetRecentProblemsListError;
	constructor(public payload?: any) {}
}

export class SetRecentProblemsList implements Action {
	public type: string = ApplicationActionType.SetRecentProblemsList;
	constructor(public payload: Problem[]) {}
}

export class DuplicateProblem implements Action {
	public type: string = ApplicationActionType.DuplicateProblem;
	constructor(public payload: DuplicateProblemPayload) {}
}

export class DuplicateProblemSuccess implements Action {
	public type: string = ApplicationActionType.DuplicateProblemSuccess;
	constructor(public payload: { caseNo: string; department: string; user: string; role: string }) {}
}

export class DuplicateProblemError implements Action {
	public type: string = ApplicationActionType.DuplicateProblemError;
	constructor(public payload?: any) {}
}

export class CloseProblem implements Action {
	public type: string = ApplicationActionType.CloseProblem;
	constructor(public payload: { problemId: number[]; resolution: string }) {}
}

export class CloseProblemSuccess implements Action {
	public type: string = ApplicationActionType.CloseProblemSuccess;
	constructor(public payload?: any) {}
}

export class CloseProblemError implements Action {
	public type: string = ApplicationActionType.CloseProblemError;
	constructor(public payload?: any) {}
}

export type ApplicationAction =
	| DownloadEdocsFile
	| DownloadAzureFile
	| DelayedAction
	| DelayedActionBy1
	| DeleteAttachment
	| DeleteContact
	| DeleteContactSuccess
	| DeleteContactError
	| DeletePhone
	| DeletePhoneSuccess
	| DeletePhoneError
	| GetMenuOption
	| Idle
	| Layer
	| GetLayers
	| CheckLayerDisplay
	| SetProblemNeighborScope
	| SetProblemNeighborScopeSuccess
	| GetProblemNeighbors
	| GetProblemNeighborsSuccess
	| GetProblems
	| GetProblemsSuccess
	| GetProblemsError
	| GetDashBoardProblems
	| GetDashBoardProblemsSuccess
	| GetDashBoardProblemsError
	| Heartbeat
	| HeartbeatSuccess
	| HeartbeatError
	| SetMenuOption
	| SetMenuDictionaries
	| SetProblems
	| SetDashBoardProblems
	| SetProblemsFiltered
	| SelectProblem
	| SetDashboardView
	| ToggleCategoryExpanded
	// ToggleProblemExpanded |
	| SetNoMapLocation
	| UpdateWindowSize
	| CancelActivity
	| CancelActivitySuccess
	| CancelActivityError
	| GetActivity
	| GetActivities
	| GetAsset
	| GetTask
	| GetTasks
	| GetTaskSuccess
	| GetTaskError
	// SetActivity |
	| SetAccess
	| SetActivities
	| SetAsset
	| SetTasks
	| SetNewCaseNo
	| SetDashboardTabView
	| AddActivity
	| AddActivitySuccess
	| AddActivityError
	| GetDashboardView
	| GetDashboardViewSuccess
	| GetDashboardViewError
	| SaveDashboardView
	| SaveDashboardViewSuccess
	| SaveDashboardViewError
	| AddAsset
	| AddAssetSuccess
	| AddAssetError
	| DeleteAsset
	| DeleteAssetSuccess
	| DeleteAssetError
	| AddCodeCase
	| AddCodeCaseSuccess
	| AddCodeCaseError
	| AddPermit
	| AddPermitSuccess
	| AddPermitError
	| AddProblem
	| UpdateActivityClose
	| UpdateActivity
	| UpdateActivitySuccess
	| UpdateActivityError
	// GetCategorySubType |
	| AddCaseGotoStep
	| SetSelectedProblemType
	| GetAllProblemSubTypes
	| SetAllProblemSubTypes
	| ReassignProblem
	| ReassignProblemSuccess
	| ReassignProblemError
	// ReassignGroupProblem |
	// ReassignGroupProblemSuccess |
	// ReassignGroupProblemError |
	| ToastUserNotification
	| RedirectPath
	| GetProblemHistory
	| GetProblemHistorySuccess
	| GetProblemHistoryError
	| UpdateProblem
	| GetDescriptionHistory
	| SetDescriptionHistory
	| SetRapUsers
	| GetProblemContacts
	| GetProblemContactsSuccess
	| GetProblemContactsError
	| AddProblemContacts
	| AddProblemContactsSuccess
	| AddProblemContactsError
	| SetProblemContacts
	| UpdateContact
	| SetZoneLookupOnly
	| SetSearchCoordinates
	| SearchCoordinates
	| SearchCoordinatesSuccess
	| SearchCoordinatesError
	| SearchFromCoordinates
	| SearchFromCoordinatesSuccess
	| SearchFromCoordinatesError
	| LookupOwner
	| LookupOwnerSuccess
	| LookupOwnerReset
	| LookupOwnerError
	| LookupOwnerAddress
	| DeletePreviousPropertyOwnerContacts
	| Search
	| SaveSearchQuery
	| SaveSearchQuerySuccess
	| SaveSearchQueryError
	| GetAllSearchQueriesSuccess
	| RemoveSavedSearchQuery
	| RemoveSavedSearchQuerySuccess
	| RemoveSavedSearchQueryError
	| SearchResults
	| SearchResultsError
	| SearchResultsSuccess
	| UpdateURLParams
	| UploadAttachments
	| UploadDocumentSuccess
	| UploadDocumentError
	| GetProblemAttachments
	| GetNewCaseMenu
	| SetNewCaseMenu
	| SetNoProblems
	| SetCompleteTask
	| SetCompleteTaskSuccess
	| SetCompleteTaskError
	| GetCityworksTransferMap
	| SetCityworksTransferMap
	| TransferringToCityworks
	| CityworksTransferRequest
	| CityworksTransferRequestSuccess
	| CityworksTransferRequestError
	| CityworksRequestView
	| CityworksRequestViewSuccess
	| CityworksRequestViewError
	| ClearCityworksRequestView
	| CreatingCodeCase
	| SetInProgressActivity
	| SetInProgressMyTask
	| ScrollToResults
	| GoToProblemDetails
	| SetAppView
	| SetViewLoading
	| GetProblemAttachmentsImages
	| GetProblemAttachmentsImagesPartialSuccess
	| GetProblemAttachmentsImagesError
	| RemoveProblemAttachments
	| RemoveProblemAttachmentsImages
	| SetProblemAttachmentsImages
	| SetProblemAttachmentsImagesNull
	| AddWorkOrder
	| AddWorkOrderSuccess
	| AddWorkOrderError
	| SubmitWorkOrder
	| SubmitWorkOrderSuccess
	| SubmitWorkOrderError
	| DeleteWorkOrderByActivityId
	| DeleteWorkOrderByActivityIdSuccess
	| DeleteWorkOrderByActivityIdError
	| UpdateProblemRead
	| GetAllProblemLinkedCases
	| GetSearchListLinkedCases
	| GetProblemLinkedCases
	| GetProblemLinkedCasesSucccess
	| GetProblemLinkedCasesError
	| GetProblemLinkedCasesAddMenu
	| GetProblemLinkedCasesAddMenuSucccess
	| GetProblemLinkedCasesAddMenuError
	| AddProblemLinkedCases
	| AddProblemLinkedCase
	| AddProblemLinkedCaseSuccess
	| AddProblemLinkedCaseSuccessToastMsg
	| AddProblemLinkedCaseError
	| UpdateLinkedCaseNotes
	| UpdateLinkedCaseNotesSuccess
	| UpdateLinkedCaseNotesError
	| RenewArcGisToken
	| RenewArcGisTokenSuccess
	| RenewArcGisTokenError
	| IsNation
	| GetIsAdminUser
	| SetIsAdminUser
	| GetUsers
	| SetUsers
	| UpdateUser
	| UpdateUserSuccess
	| UpdateUserError
	| SetAdminSection
	| GetProfilePicture
	| SetProfilePicture
	| AdminCreateNewUser
	| GetGroups
	| SetGroups
	| GetRoles
	| SetRoles
	| UpdateGroup
	| UpdateGroupSuccess
	| UpdateGroupError
	| UpdateRole
	| UpdateRoleSuccess
	| UpdateRoleError
	| AdminCreateNewRole
	| AdminCreateNewGroup
	| GetADUsersList
	| SetADUsersList
	| GetRecentProblemsList
	| GetRecentProblemsListSuccess
	| GetRecentProblemsListError
	| SetRecentProblemsList
	| DuplicateProblem
	| DuplicateProblemSuccess
	| DuplicateProblemError;
